// Currency configuration
export const currencies = {
  INR: { code: 'INR', symbol: '\u20B9', name: 'Indian Rupee', locale: 'en-IN', useIndian: true },
  USD: { code: 'USD', symbol: '$', name: 'US Dollar', locale: 'en-US', useIndian: false },
  EUR: { code: 'EUR', symbol: '\u20AC', name: 'Euro', locale: 'de-DE', useIndian: false },
  GBP: { code: 'GBP', symbol: '\u00A3', name: 'British Pound', locale: 'en-GB', useIndian: false },
};

export function formatMoney(value, currencyCode = 'INR') {
  const c = currencies[currencyCode] || currencies.INR;
  const num = Math.round(Number(value) || 0);
  const formatted = new Intl.NumberFormat(c.locale, { maximumFractionDigits: 0 }).format(num);
  return c.symbol + formatted;
}

export function formatMoneyShort(value, currencyCode = 'INR') {
  const c = currencies[currencyCode] || currencies.INR;
  const num = Math.round(Number(value) || 0);
  if (c.useIndian) {
    if (num >= 10000000) return c.symbol + (num / 10000000).toFixed(2) + ' Cr';
    if (num >= 100000) return c.symbol + (num / 100000).toFixed(2) + ' L';
    if (num >= 1000) return c.symbol + (num / 1000).toFixed(1) + ' K';
    return c.symbol + num.toLocaleString(c.locale);
  }
  if (num >= 1_000_000_000) return c.symbol + (num / 1_000_000_000).toFixed(2) + 'B';
  if (num >= 1_000_000) return c.symbol + (num / 1_000_000).toFixed(2) + 'M';
  if (num >= 1_000) return c.symbol + (num / 1_000).toFixed(1) + 'K';
  return c.symbol + num.toLocaleString(c.locale);
}

export function parseMoneyInput(str) {
  if (typeof str !== 'string') str = String(str ?? '');
  const cleaned = str.replace(/[^\d.]/g, '');
  const n = Number(cleaned);
  return isNaN(n) ? 0 : n;
}
